import { Sanity } from 'src/types/sanity';
import styled from 'styled-components';

export const Button = styled.button<{ $tone: Sanity.Types.SanityTone }>`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 0.333rem;
  min-width: 12em;
  padding: 0.5rem 0.75rem;
  border-radius: 3px;
  border: 1px solid ${({ $tone }) => Sanity.Types.SanityToneColors[$tone]};
  background: ${({ $tone }) => Sanity.Types.SanityToneColors[$tone]};
  color: #000;
  cursor: pointer;
  /* font-size: 1.25rem; */
  font-family: 'akzidenz-grotesk', helvetica, 'helvetica neue', arial, sans-serif;
  font-weight: bold;
  transition: filter 0.25s ease-in-out;
  user-select: none;

  &:hover, &:focus {
    filter: brightness(1.1);
  }

  &:disabled {
    /* opacity: 0.6; */
    cursor: not-allowed;
    color: ${({ $tone }) => Sanity.Types.SanityToneColors[$tone]};
    background-color: transparent;
  }


`;

export const ButtonIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1rem;
  height: 1rem;
  vertical-align: middle;
  flex-shrink: 0;
  line-height: 1;
`;

export const ButtonText = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  vertical-align: middle;
  flex-shrink: 0;
  line-height: 1;
`;
